 

   <button mat-raised-button color="primary" (click)="ajouter()" >  Ajouter Contrat</button>
 
   <p-table [columns]="cols" [value]="modelsPjoints"  selectionMode="single" [(selection)]="selectedModelpjointe" >
       
       
      <ng-template pTemplate="body" let-item> 
          <tr>
              <td>
                              
    
      <a style="color: blue;cursor: pointer;font-weight: inherit;background: rgb(246, 246, 246)" (click)='openFile(item)'> 
        {{item.designation}}</a>
              </td>
              <td>
          
            
               <button mat-raised-button (click)="remove(item)" class="btn-danger">Remove</button>
               
              </td>
          </tr>
      </ng-template>
      
     
    </p-table>
  
    <div style="margin-bottom: 300px;"></div>
   
  
  
  <p-dialog header="header" [(visible)]="editDialog" [modal]="true" [responsive]="true" >
    <div style="padding: 28px;">
      <div class="row">
        SALON:
      <p-listbox [options]="salons" [(ngModel)]="salon"></p-listbox>
      </div>
 
  <div *ngIf="false">
    Designation 
    <input type="text" [(ngModel)]="designationPjoint" width="600"> 
    
  </div>

  <div style="height:70px;"></div>
  <div class="row">
  
    <p-fileUpload name="name" url="{{uploadUrl}}"  mode="basic" auto="true" chooseLabel="Choose Model Attachment"
     (onUpload)="uploadFunction($event)"
    [multiple]="false"   maxFileSize="100000000">
     
    </p-fileUpload>
    </div>


     
  <div class="row" style="margin-top: 100px">
    <button (click)="save()">Sauvgarder</button>  <button (click)="editDialog=false">Annuler</button>
  </div>
   
    </div>
   

  
  </p-dialog>
   